import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import { initialMorphologicCodeModalState, IContentMorphologicCodeGrid } from '@/modules/configurationModule/detail/samples/morphology/MorphologicCode.models'

@Component
export default class MorphologicCodeModal extends Vue {
    @Ref() readonly morphologicCodeModal!: any
    @Prop(String) readonly actionTitle!: string
    @Emit()
    update(topography: IContentMorphologicCodeGrid[]): IContentMorphologicCodeGrid[] {
        return topography
    }
    @Emit()
    create(topography: IContentMorphologicCodeGrid) {
        return topography
    }
    private state: IContentMorphologicCodeGrid

    constructor() {
        super()
        this.state = initialMorphologicCodeModalState()
    }

    get canUpdateOrCreate(): boolean {
        return Object.keys(this.fields).some((key: any) => {
            return this.fields?.[key]?.dirty
        })
    }

    get modelValidated(): boolean {
        const modelValidated = !!this.state.code && !!this.state.description
        const hasErrors = !!this.errors.count()
        return this.canUpdateOrCreate && !hasErrors && modelValidated
    }

    async show(selectedRow: IContentMorphologicCodeGrid): Promise<void> {
        this.state = initialMorphologicCodeModalState()
        await this.$validator.reset()
        if (selectedRow) {
            this.state = { ...selectedRow }
        }
        this.morphologicCodeModal.show()
    }

    hide() { this.morphologicCodeModal.hide() }

    actionModal() {
        if (this.state?.id) {
            this.update([this.state])
        } else {
            this.create(this.state)
        }
    }
}
